import { render, staticRenderFns } from "./FrequenceDaysSelection.vue?vue&type=template&id=e3fd27ca"
import script from "./FrequenceDaysSelection.vue?vue&type=script&lang=ts"
export * from "./FrequenceDaysSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports